import { Field } from 'formik';
import React from 'react';
import { Checkbox } from './fields/Checkbox/Checkbox';
import { Color } from './fields/Color/Color';
import { Header } from './fields/Header/Header';
import { Input } from './fields/Input/Input';
import { Radio } from './fields/Radio/Radio';
import { Range } from './fields/Range/Range';
import { Select } from './fields/Select/Select';
function isEditableSetting(setting) {
    return 'id' in setting;
}
const settingsComponents = (type) => {
    const fieldTypes = {
        checkbox: Checkbox,
        color: Color,
        header: Header,
        number: Input,
        radio: Radio,
        range: Range,
        select: Select,
        text: Input,
        // unused
        app_button: null,
        collection: null,
        currency: null,
        date_picker: null,
        font_picker: null,
        html: null,
        image_picker: null,
        memberships_access_type_picker: null,
        memberships_tag_post_picker: null,
        memberships_type_post_picker: null,
        memberships_video_series_picker: null,
        paragraph: null,
        product_selector: null,
        resource: null,
        richtext: null,
        social_link: null,
        url: null,
        video_picker: null,
        video_url: null,
        textarea: null,
        link_list: null,
    };
    return fieldTypes[type];
};
const InvalidSetting = (props) => {
    return React.createElement("div", null,
        "Invalid setting: ",
        props.setting.type);
};
export const PreviewSetting = ({ setting, onSettingUpdate, onAssetUpload, onAssetRemove, }) => {
    const component = settingsComponents(setting.type);
    if (!component)
        return React.createElement(InvalidSetting, { setting: setting });
    if (isEditableSetting(setting)) {
        return (React.createElement("div", null,
            React.createElement(Field, { name: setting.id, component: component, data: setting, onSettingUpdate: onSettingUpdate, onAssetUpload: onAssetUpload, onAssetRemove: onAssetRemove })));
    }
    if (setting.type === 'header') {
        return (React.createElement("div", null,
            React.createElement(Header, { data: setting })));
    }
    return React.createElement(InvalidSetting, { setting: setting });
};
